import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import '../../styles/Dashboard.css';
import Typography from '../../components/Typography';
// import OverviewCustomCard1 from '../../components/OverviewCustomCard1';
import TimeList from '../../components/TimeList';
import MilestoneList from '../../components/MilestoneList';
import CustomRange from '../../components/CustomRange';
import CustomButton from '../../components/CustomButton';
import CustomModal from '../../components/CustomModal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { /* format, toZonedTime,  */getTimezoneOffset } from 'date-fns-tz';
import moment from 'moment-timezone';
import CustomCopyClipboard from '../../components/CustomCopyClipboard';
// Format large numbers (e.g., 560000 -> $560K, 5000 -> $5K, 5833.33 -> $5.83K)
const formatNumber = (value) => {
  if (value >= 1000000) return `$${(value / 1000000).toFixed(3)}M`;
  if (value >= 1000) {
    const thousands = value / 1000;
    return thousands % 1 === 0 ? `$${thousands}K` : `$${(value / 1000).toFixed(2)}K`;
  }
  return `$${value.toLocaleString()}`;
};

const Investment = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [userInvestments, setUserInvestments] = useState([]);
  const [openLicense, setOpenLicense] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [openMarkPayout, setOpenMarkPayout] = useState(false);
  const [openConfirmRecentRoiPayout, setOpenConfirmRecentRoiPayout] = useState(false);
  const [openValidationErrorModal, setOpenValidationErrorModal] = useState(false);
  const [roiPayout, setRoiPayout] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [openCustomModal, setOpenCustomModal] = useState(false);
  const [customModalType, setCustomModalType] = useState('');
  const [customModalMessage, setCustomModalMessage] = useState('');
  const [customModalTitle, setCustomModalTitle] = useState('');
  const [customModalButtonText, setCustomModalButtonText] = useState('');
  const [openReviewModal, setOpenReviewModal] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activateId, setActivateId] = useState(null);
  const [rejectId, setRejectId] = useState(null);
  const [wireConfirmId, setWireConfirmId] = useState(null);
  const [newNotification, setNewNotification] = useState({
    name: '',
    message: '',
    sendsTo: 'investors',
    date: null,
    time: null,
  });
  const fetchUser = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(response.data.user);
      setUserInvestments(response.data.investments);
    } catch (error) {
      localStorage.removeItem('token');
      navigate('/');
    }
  }, [navigate, id]);
  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  // Calculate overview stats
  // const calculateOverviewStats = () => {
  //   const investments = userInvestments?.filter(
  //     (inv) => inv.status === 'completed'
  //   ) || [];

  //   const totalInvested = investments.reduce((sum, inv) => sum + inv.initialInvestment, 0);
  //   const totalROI = investments.reduce((sum, inv) => sum + inv.totalROI, 0);
  //   const currentROI = investments.reduce((sum, inv) => {
  //     const now = new Date();
  //     const startDate = new Date(inv.startDate);
  //     const monthsElapsed = Math.floor((now - startDate) / (1000 * 60 * 60 * 24 * 30));
  //     const currentMonthIndex = Math.min(monthsElapsed, inv.monthlyBreakdown.length - 1);
  //     return sum + (inv.monthlyBreakdown[currentMonthIndex]?.accumulatedReturn || 0);
  //   }, 0);
  //   const averageROI = investments.length > 0
  //     ? (investments.reduce((sum, inv) => sum + inv.annualROI, 0) / investments.length).toFixed(1)
  //     : 0;

  //   return { totalInvested, currentROI, totalReturn: totalROI - currentROI, averageROI };
  // };

  // const { totalInvested, currentROI, totalReturn, averageROI } = calculateOverviewStats();

  // Calculate days remaining for each investment
  const calculateDaysRemaining = (endDate) => {
    const now = new Date();
    const end = new Date(endDate);
    const diff = end - now;
    return diff <= 0 ? 0 : Math.floor(diff / (1000 * 60 * 60 * 24));
  };

  // Calculate current amount for each investment
  const calculateCurrentAmount = (investment) => {
    const now = new Date();
    const startDate = new Date(investment.startDate);
    const monthsElapsed = Math.floor((now - startDate) / (1000 * 60 * 60 * 24 * 30));
    const currentMonthIndex = Math.min(monthsElapsed, investment.monthlyBreakdown.length - 1);
    return investment.monthlyBreakdown[currentMonthIndex]?.accumulatedReturn || 0;
  };

  // Calculate time remaining in days, hours, minutes, seconds
  const calculateTimeRemaining = (endDate) => {
    const now = new Date();
    const end = new Date(endDate);
    const diff = end - now;

    if (diff <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds };
  };

  // Calculate time-based progress
  // const calculateTimeProgress = (startDate, endDate) => {
  //   if (!startDate || !endDate) return 0;

  //   const now = new Date();
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);
  //   const elapsedMs = now - start;
  //   const totalMs = end - start;
  //   const elapsedSeconds = elapsedMs / 1000;
  //   const totalSeconds = totalMs / 1000;
  //   const progress = (elapsedSeconds / totalSeconds) * 100;

  //   return Math.min(Math.max(progress, 0), 100);
  // };

  // Get the oldest active investment
  const oldestInvestment = userInvestments[activeIndex];

  // Calculate nextPayout and remainingPayout
  const calculatePayouts = (investment) => {
    if (!investment) return { nextPayout: 0, remainingPayout: 0 };

    const now = new Date();
    const startDate = new Date(investment.startDate);
    const monthsElapsed = Math.floor((now - startDate) / (1000 * 60 * 60 * 24 * 30));
    const currentMonthIndex = Math.min(monthsElapsed, investment.monthlyBreakdown.length - 1);
    const currentAccumulated = investment.monthlyBreakdown[currentMonthIndex]?.accumulatedReturn || 0;

    // Next payout: ROI for the next milestone (difference between current and next month's accumulated return)
    const nextMonthIndex = Math.min(currentMonthIndex + 1, investment.monthlyBreakdown.length - 1);
    const nextPayout = investment.monthlyBreakdown[nextMonthIndex]?.accumulatedReturn
      ? investment.monthlyBreakdown[nextMonthIndex].accumulatedReturn - currentAccumulated
      : investment.monthlyROI || 0; // Fallback to monthlyROI if no next milestone data

    // Remaining payout: Total ROI minus current accumulated return
    const totalPaid = investment.payouts.reduce((sum, payout) => sum + payout.amount, 0);
    const remainingPayout = investment.totalROI - totalPaid;

    return { nextPayout, remainingPayout };
  };

  const { nextPayout, remainingPayout } = oldestInvestment ? calculatePayouts(oldestInvestment) : { nextPayout: 0, remainingPayout: 0 };

  const milestoneInterval = oldestInvestment ? oldestInvestment.term === 12 ? 1 : Math.floor(oldestInvestment.term / 6) : 1;
  const milestones = oldestInvestment
    ? [
      { month: 0, accumulatedReturn: 0 },
      ...oldestInvestment.monthlyBreakdown.filter(entry => entry.month % milestoneInterval === 0),
      oldestInvestment.monthlyBreakdown[oldestInvestment.monthlyBreakdown.length - 1],
    ].slice(0, oldestInvestment.term === 12 ? 13 : 30).map((entry) => ({
      label: entry.month === 0 ? 'Start' : `Month ${entry.month}`,
      subLabel: formatNumber(entry.accumulatedReturn),
      position: (entry.month / oldestInvestment.term) * 100,
    }))
    : [];

  const [timeRemaining, setTimeRemaining] = useState(
    oldestInvestment
      ? calculateTimeRemaining(oldestInvestment.endDate)
      : { days: 0, hours: 0, minutes: 0, seconds: 0 }
  );
  useEffect(() => {
    if (!oldestInvestment) {
      setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      return;
    }

    const timer = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining(oldestInvestment.endDate));
    }, 1000);

    return () => clearInterval(timer);
  }, [oldestInvestment]);

  // const timeRemaining = oldestInvestment
  //   ? calculateTimeRemaining(oldestInvestment.endDate)
  //   : { days: 0, hours: 0, minutes: 0, seconds: 0 };

  // Calculate payout-based progress
  const calculatePayoutProgress = (investment) => {
    if (!investment) return 0;
    const totalPaid = investment.payouts.reduce((sum, payout) => sum + payout.amount, 0);
    const totalROI = investment.totalROI;
    return totalROI > 0 ? Math.min((totalPaid / totalROI) * 100, 100) : 0;
  };

  const progress = calculatePayoutProgress(oldestInvestment);
  // const progress = oldestInvestment
  //   ? calculateTimeProgress(oldestInvestment.startDate, oldestInvestment.endDate)
  //   : 0;

  const currentAmount = oldestInvestment ? calculateCurrentAmount(oldestInvestment) : 0;

  // Handle "View" button click to navigate to investment details
  // const handleViewInvestment = (investmentId) => {
  //   navigate(`/investment/${investmentId}`);
  // };

  const handleConfirmRecentRoiPayout = async () => {
    try {
      const token = localStorage.getItem('token');
      const investmentId = oldestInvestment?._id;
      setOpenConfirmRecentRoiPayout(false);
      setShowLoadingModal(true);
      // Send the payout data to the backend
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/investment/mark-payout/${investmentId}`,
        { amount: parseFloat(roiPayout) },
        { headers: { Authorization: `Bearer ${token}` } }
      );


      if (response.data.success) {
        // Update local state with the new investment data
        const updatedInvestments = userInvestments.map((inv, idx) =>
          idx === activeIndex ? response.data.investment : inv
        );
        setUserInvestments(updatedInvestments);

        // Show success modal
        setOpenCustomModal(true);
        setCustomModalType('success');
        setCustomModalMessage('Payout successfully updated. You may now close this screen.');
        setCustomModalTitle('ALL DONE!');
        setCustomModalButtonText('COMPLETE');
        setRoiPayout(0); // Reset the payout input
        setShowLoadingModal(false);
      }
    } catch (error) {
      setOpenConfirmRecentRoiPayout(false);
      console.error('Error marking payout:', error);
      setOpenCustomModal(true);
      setShowLoadingModal(false);
      setCustomModalType('error');
      setCustomModalMessage('Failed to mark payout. Please try again.');
      setCustomModalTitle('ERROR');
      setCustomModalButtonText('CLOSE');
    }
  };

  // Detect user's timezone
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Map IANA timezones to common names and abbreviations
  const timezoneMapping = {
    'America/New_York': { name: 'Eastern Time', abbr: 'EST' },
    'America/Chicago': { name: 'Central Time', abbr: 'CST' },
    'America/Denver': { name: 'Mountain Time', abbr: 'MST' },
    'America/Los_Angeles': { name: 'Pacific Time', abbr: 'PST' },
    'Asia/Kolkata': { name: 'India Time', abbr: 'IST' },
    'Europe/London': { name: 'British Time', abbr: 'GMT' },
    'Asia/Tokyo': { name: 'Japan Time', abbr: 'JST' },
    'Australia/Sydney': { name: 'Sydney Time', abbr: 'AEST' },
    'UTC': { name: 'Coordinated Universal Time', abbr: 'UTC' },
  };

  const getTimezoneInfo = (timezone) => {
    const mapping = timezoneMapping[timezone] || { name: timezone, abbr: timezone.split('/')[1] || timezone };
    const date = new Date();
    const offsetMinutes = getTimezoneOffset(timezone, date) / 60; // Convert to minutes
    const offsetHours = offsetMinutes / 60;
    const offsetSign = offsetHours >= 0 ? '+' : '-';
    const offsetAbs = Math.abs(offsetHours);
    const offsetFormatted = `${offsetSign}${Math.floor(offsetAbs)}:${(offsetAbs % 1) * 60 || '00'}`;
    return {
      name: mapping.name,
      abbr: mapping.abbr,
      offset: offsetFormatted,
    };
  };

  const timezoneInfo = getTimezoneInfo(userTimezone);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewNotification((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (date) => {
    setNewNotification((prev) => ({
      ...prev,
      date: date ? date : null,
    }));
  };

  const handleTimeChange = (time) => {
    if (!time) {
      setNewNotification((prev) => ({
        ...prev,
        time: null,
      }));
      return;
    }

    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timeMoment = moment.tz(time, userTimezone);
    const formattedTime = timeMoment.format('hh:mm A'); // e.g., "12:00 PM"
    const abbr = timeMoment.format('z'); // e.g., "IST"
    const offset = timeMoment.format('Z'); // e.g., "+05:30"
    const timezoneString = `(${abbr} ${offset}) ${timezoneInfo.name}`; // e.g., "(IST +05:30) India Time"

    const displayTime = `${formattedTime} ${timezoneString}`; // e.g., "12:00 PM (IST +05:30) India Time"

    setNewNotification((prev) => ({
      ...prev,
      time: {
        value: formattedTime, // For backend: "12:00 PM"
        timezone: timezoneString, // For backend: "(IST +05:30) India Time"
        raw: time.toISOString(), // For DatePicker
        display: displayTime, // For UI display
      },
    }));
  };

  const handleNotificationSubmit = async () => {
    // Validate inputs
    if (!newNotification.name || !newNotification.message || !newNotification.date || !newNotification.time) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const notificationData = {
        name: newNotification.name,
        message: newNotification.message,
        sendsTo: newNotification.sendsTo,
        date: newNotification.date ? moment(newNotification.date.toISOString()).format('YYYY-MM-DD') : '',
        time: newNotification.time.value, // e.g., "12:00 PM"
        timezone: newNotification.time.timezone, // e.g., "(IST +05:30) India Time"
        delivery: newNotification.time.value + ' | ' + moment(newNotification.date.toISOString()).format('DD MMM YY'),
        email: user?.email
      };
      console.log(notificationData);

      //Implement email sending logic here

      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/notifications/send-email`, notificationData, {
        headers: { Authorization: `Bearer ${token}` },
      }).then(res => {
        if (res.data.success === true) {
          setOpenCustomModal(true);
          setCustomModalButtonText('RETURn TO DASHBOARD');
          setCustomModalTitle('Email sent!');
          setCustomModalMessage('email successfully sent. You may now close this screen.');
          setCustomModalType('success');

          setNewNotification({
            name: '',
            message: '',
            sendsTo: 'investors',
            date: null,
            time: null,
          });
        }
      });

    } catch (error) {
      console.error('Error creating notification:', error);
    }
  }

  const sendWireReminder = useCallback(async (investmentId) => {
    setIsLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/investment/wire-transfer-reminder/${investmentId}`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response);
      if (response.status === 200) {
        setCustomModalType('success');
        setCustomModalTitle('Success');
        setCustomModalMessage('Wire transfer reminder sent successfully. Please check your email.');
        setCustomModalButtonText('Close');
        setOpenCustomModal(true);
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to send wire transfer reminder');
    } finally {
      setIsLoading(false);
      fetchUser();
    }
  }, [fetchUser]);

  const handleShowActiveModal = (investmentId) => {
    setActivateId(investmentId);
    setCustomModalType('question');
    setCustomModalTitle('Activate Investment?');
    setCustomModalMessage('Are you sure you want to activate this investment? This will move it from Pending to Active and start the ROI countdown.');
    setCustomModalButtonText('Confirm & Activate');
    setOpenCustomModal(true);
  }

  const handleShowRejectModal = (investmentId) => {
    setRejectId(investmentId);
    setCustomModalType('question');
    setCustomModalTitle('Reject Investment?');
    setCustomModalMessage('Are you sure you want to reject this investment? The investor will be notified, and funds will not be activated.');
    setCustomModalButtonText('Reject Investment');
    setOpenCustomModal(true);
  }

  const handleShowWireModal = (investmentId) => {
    setWireConfirmId(investmentId);
    setCustomModalType('question');
    setCustomModalTitle('Wire Transfer Reminder?');
    setCustomModalMessage('Are you sure you want to send a wire transfer reminder to this investor?');
    setCustomModalButtonText('Confirm & Send');
    setOpenCustomModal(true);
  }

  const handleActiveInvestment = useCallback(async (investmentId) => {
    setIsLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/investment/active/${investmentId}`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response);
      if (response.status === 200) {
        setCustomModalType('success');
        setCustomModalTitle('Success');
        setCustomModalMessage('Investment marked as active successfully.');
        setCustomModalButtonText('Close');
        setOpenCustomModal(true);
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to mark investment as active');
    } finally {
      setIsLoading(false);
      fetchUser();
    }
  }, [fetchUser])

  const handleDecline = useCallback(async (investmentId) => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/investment/decline/${investmentId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` }, timeout: 10000 }
      );
      if (res.data.success) {
        setOpenCustomModal(true);
        setCustomModalType('success');
        setCustomModalTitle('INVESTOR DECLINED!');
        setCustomModalMessage(res.data.message);
        setCustomModalButtonText('RETURN TO DASHBOARD');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to decline investor. Please try again.');
    } finally {
      setIsLoading(false);
      fetchUser();
    }
  }, [fetchUser]
  );

  // const handleTestNotification = async () => {
  //   const token = localStorage.getItem('token');
  //   const notificationData = {
  //     title: 'Payoueewwrt Received',
  //     name: 'Investmewenwewqt Update',
  //     message: `A payowewut of has been marked for your investment.`,
  //     sendsTo: 'we',
  //     _id: Math.random(),
  //     date: new Date().toISOString().split('T')[0],
  //     time: moment().format('hh:mm A'),
  //     timezone: '(UTC +00:00) Etc/GMT',
  //     delivery: `${moment().format('hh:mm A')} | ${moment().format('DD MMM YY')}`,
  //     sends: 1,
  //     status: 'Sent',
  //     read: false
  //   }

  //   const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/investment/send-notification`, notificationData, { headers: { Authorization: `Bearer ${token}` } });
  //   console.log(response.data.message);
  // }

  return (
    <div>
      {showLoadingModal && (
        <CustomModal
          type="loading"
          title="Please wait"
          confirmButton={false}
          message="Please wait while we mark payout for your investment ..."
          onClose={() => setShowLoadingModal(false)}
          colseText="Okay"
        />
      )}
      {(isLoading || error) && (
        <CustomModal
          type={error ? 'error' : 'loading'}
          title={error ? 'Error' : 'Please wait'}
          message={error || 'Please wait while we process your request...'}
          confirmButton={!!error}
          onClose={() => setError(null)}
          colseText={error ? 'Try Again' : undefined}
        />
      )}
      {openCustomModal && <CustomModal type={customModalType} title={customModalTitle} message={customModalMessage} onClose={() => setOpenCustomModal(false)} onConfirm={() => { if (customModalTitle === 'NOTIFICATION sent!') { navigate('/admin/notifications'); } if (customModalTitle === 'READY To SEND?') { handleNotificationSubmit(); } if (customModalTitle === 'Activate Investment?') { handleActiveInvestment(activateId); } if (customModalTitle === 'Reject Investment?') { handleDecline(rejectId); } if (customModalTitle === 'Wire Transfer Reminder?') { sendWireReminder(wireConfirmId); } setOpenCustomModal(false); }} colseText={customModalButtonText} />}
      {openReviewModal && <div className="fixed fade inset-0 z-50 flex items-center h-full justify-center bg-black bg-opacity-60 animate-backdropFadeIn">
        <div className="relative w-[464px] mx-auto animate-modalSlideIn">
          <svg xmlns="http://www.w3.org/2000/svg" width="464" height="702" viewBox="0 0 464 702" fill="none">
            <path d="M0 57.4186L41.0651 0H464V702H0V57.4186Z" fill="#1B1B1B" />
          </svg>
          <div className="absolute inset-0 py-[42px] px-[66px] items-center text-white">
            {/* Close Icon */}
            <button
              onClick={() => setOpenReviewModal(false)}
              className="absolute top-6 right-6 text-white text-lg hover:text-gray-300"
              aria-label="Close modal"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <g opacity="0.6">
                  <mask id="mask0_1769_5697" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="30" height="30">
                    <rect width="30" height="30" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1769_5697)">
                    <path d="M8.00078 23.317L6.68359 21.9998L13.6836 14.9998L6.68359 7.99981L8.00078 6.68262L15.0008 13.6826L22.0008 6.68262L23.318 7.99981L16.318 14.9998L23.318 21.9998L22.0008 23.317L15.0008 16.317L8.00078 23.317Z" fill="white" />
                  </g>
                </g>
              </svg>
            </button>
            <Typography text={'SEND notification'} size={'27.752px'} weight={450} transform={'uppercase'} family={'Supply'} color={'#FFF'} lineheight={'60px'} />
            <form onSubmit={() => {
              setOpenReviewModal(false);
              setOpenCustomModal(true);
              setCustomModalType('confirm'); // setCustomModalType('confirm');
              setCustomModalTitle('READY To SEND?');
              setCustomModalButtonText('Correct send');
              setCustomModalMessage(<><span className='text-[#848484]'>Email is sending to <br /></span><span className='text-white'>| {user?.email} |<br /></span><span className='text-[#8E8E8E]'>Is this correct?<br /></span></>);
            }} className="space-y-5">
              {/* <div>
                <input
                  type="text"
                  name="title"
                  value={newNotification.title}
                  onChange={handleInputChange}
                  style={{ fontFamily: 'Aeonik' }}
                  className="w-full bg-transparent outline-none border-b border-[#FFF] border-opacity-40 text-white py-4 focus:outline-none text-opacity-40 text-[14px]"
                  placeholder="Title"
                  required
                />
              </div> */}
              <div className="relative">
                <input
                  type="text"
                  name="name"
                  value={newNotification.name}
                  onChange={handleInputChange}
                  style={{ fontFamily: 'Aeonik' }}
                  className={`w-full bg-transparent outline-none border-b border-[#FFF] border-opacity-40 text-white py-4 focus:outline-none ${!newNotification.name ? 'text-opacity-40' : 'text-opacity-100'} text-[14px]`}
                  placeholder="Notification Title"
                  required
                />
                {/* <svg xmlns="http://www.w3.org/2000/svg" className="absolute top-5 right-3" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g opacity="0.4">
                    <path d="M10 1.25C5.16797 1.25 1.25 5.16797 1.25 10C1.25 14.832 5.16797 18.75 10 18.75C14.832 18.75 18.75 14.832 18.75 10C18.75 5.16797 14.832 1.25 10 1.25ZM10 17.2656C5.98828 17.2656 2.73438 14.0117 2.73438 10C2.73438 5.98828 5.98828 2.73438 10 2.73438C14.0117 2.73438 17.2656 5.98828 17.2656 10C17.2656 14.0117 14.0117 17.2656 10 17.2656Z" fill="white" />
                    <path d="M12.1797 6.18555C11.5937 5.67188 10.8203 5.39062 10 5.39062C9.17969 5.39062 8.40625 5.67383 7.82031 6.18555C7.21094 6.71875 6.875 7.43555 6.875 8.20312V8.35156C6.875 8.4375 6.94531 8.50781 7.03125 8.50781H7.96875C8.05469 8.50781 8.125 8.4375 8.125 8.35156V8.20312C8.125 7.3418 8.9668 6.64062 10 6.64062C11.0332 6.64062 11.875 7.3418 11.875 8.20312C11.875 8.81055 11.4453 9.36719 10.7793 9.62305C10.3652 9.78125 10.0137 10.0586 9.76172 10.4219C9.50586 10.793 9.37305 11.2383 9.37305 11.6895V12.1094C9.37305 12.1953 9.44336 12.2656 9.5293 12.2656H10.4668C10.5527 12.2656 10.623 12.1953 10.623 12.1094V11.666C10.6241 11.4764 10.6822 11.2915 10.7898 11.1354C10.8975 10.9793 11.0497 10.8593 11.2266 10.791C12.3789 10.3477 13.123 9.33203 13.123 8.20312C13.125 7.43555 12.7891 6.71875 12.1797 6.18555ZM9.21875 14.2969C9.21875 14.5041 9.30106 14.7028 9.44757 14.8493C9.59409 14.9958 9.7928 15.0781 10 15.0781C10.2072 15.0781 10.4059 14.9958 10.5524 14.8493C10.6989 14.7028 10.7812 14.5041 10.7812 14.2969C10.7812 14.0897 10.6989 13.891 10.5524 13.7444C10.4059 13.5979 10.2072 13.5156 10 13.5156C9.7928 13.5156 9.59409 13.5979 9.44757 13.7444C9.30106 13.891 9.21875 14.0897 9.21875 14.2969Z" fill="white" />
                  </g>
                </svg> */}
              </div>
              <div>
                <textarea
                  name="message"
                  value={newNotification.message}
                  rows={7}
                  onChange={handleInputChange}
                  style={{ fontFamily: 'Aeonik' }}
                  className={`w-full bg-transparent outline-none border-b border-[#FFF] border-opacity-40 text-white py-4 focus:outline-none ${!newNotification.message && 'text-opacity-40'} text-[14px] resize-none`}
                  placeholder="Write message here..."
                  required
                />
              </div>
              <Typography text={'scheduling'} transform={'uppercase'} color={'#FFF'} size={'16px'} weight={400} lineheight={'170%'} family={'Supply'} />
              <Typography text={'Sends to your investors'} color={'#FFF'} size={'14px'} weight={400} lineheight={'170%'} />
              <div className="relative">
                <DatePicker
                  selected={newNotification.date}
                  icon={<svg xmlns="http://www.w3.org/2000/svg" className="absolute top-3 right-0" width="22" height="23" viewBox="0 0 22 23" fill="none">
                    <g opacity={newNotification.date ? '1' : '0.4'}>
                      <mask id="mask0_1797_7527" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="23">
                        <rect x="0.0546875" y="0.212402" width="21.9469" height="21.9469" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_1797_7527)">
                        <path d="M4.62578 20.3302C4.12283 20.3302 3.69228 20.1511 3.33412 19.793C2.97596 19.4348 2.79688 19.0043 2.79688 18.5013V5.69895C2.79688 5.196 2.97596 4.76545 3.33412 4.40729C3.69228 4.04913 4.12283 3.87005 4.62578 3.87005H5.54024V2.04114H7.36915V3.87005H14.6848V2.04114H16.5137V3.87005H17.4281C17.9311 3.87005 18.3616 4.04913 18.7198 4.40729C19.078 4.76545 19.2571 5.196 19.2571 5.69895V18.5013C19.2571 19.0043 19.078 19.4348 18.7198 19.793C18.3616 20.1511 17.9311 20.3302 17.4281 20.3302H4.62578ZM4.62578 18.5013H17.4281V9.35677H4.62578V18.5013ZM4.62578 7.52786H17.4281V5.69895H4.62578V7.52786Z" fill="white" />
                      </g>
                    </g>
                  </svg>}
                  showIcon={true}
                  toggleCalendarOnIconClick={true}
                  onChange={handleDateChange}
                  dateFormat="dd/MM/yyyy"
                  className={`w-full bg-transparent outline-none border-b border-[#FFF] border-opacity-40 text-white py-2 focus:outline-none ${!newNotification.date ? 'text-opacity-40' : ''} text-[14px]`}
                  placeholderText="Date"
                  style={{ fontFamily: 'Aeonik' }}
                  required
                />
              </div>
              <div className="relative">
                <DatePicker
                  selected={newNotification.time?.raw ? new Date(newNotification.time.raw) : null}
                  value={newNotification.time?.display}
                  icon={<svg xmlns="http://www.w3.org/2000/svg" className="absolute top-3 right-0" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <g opacity={newNotification.time?.raw ? 1 : 0.4}>
                      <mask id="mask0_579_387" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_579_387)">
                        <path d="M12.7513 13.9165L13.918 12.7498L10.8346 9.6665V5.83317H9.16797V10.3332L12.7513 13.9165ZM10.0013 18.3332C8.84852 18.3332 7.76519 18.1144 6.7513 17.6769C5.73741 17.2394 4.85547 16.6457 4.10547 15.8957C3.35547 15.1457 2.76172 14.2637 2.32422 13.2498C1.88672 12.2359 1.66797 11.1526 1.66797 9.99984C1.66797 8.84706 1.88672 7.76373 2.32422 6.74984C2.76172 5.73595 3.35547 4.854 4.10547 4.104C4.85547 3.354 5.73741 2.76025 6.7513 2.32275C7.76519 1.88525 8.84852 1.6665 10.0013 1.6665C11.1541 1.6665 12.2374 1.88525 13.2513 2.32275C14.2652 2.76025 15.1471 3.354 15.8971 4.104C16.6471 4.854 17.2409 5.73595 17.6784 6.74984C18.1159 7.76373 18.3346 8.84706 18.3346 9.99984C18.3346 11.1526 18.1159 12.2359 17.6784 13.2498C17.2409 14.2637 16.6471 15.1457 15.8971 15.8957C15.1471 16.6457 14.2652 17.2394 13.2513 17.6769C12.2374 18.1144 11.1541 18.3332 10.0013 18.3332ZM10.0013 16.6665C11.8485 16.6665 13.4214 16.0172 14.7201 14.7186C16.0187 13.42 16.668 11.8471 16.668 9.99984C16.668 8.15262 16.0187 6.5797 14.7201 5.28109C13.4214 3.98248 11.8485 3.33317 10.0013 3.33317C8.15408 3.33317 6.58116 3.98248 5.28255 5.28109C3.98394 6.5797 3.33464 8.15262 3.33464 9.99984C3.33464 11.8471 3.98394 13.42 5.28255 14.7186C6.58116 16.0172 8.15408 16.6665 10.0013 16.6665Z" fill="white" />
                      </g>
                    </g>
                  </svg>}
                  showIcon={true}
                  toggleCalendarOnIconClick={true}
                  onChange={handleTimeChange}
                  timeFormat="h:mm aa"
                  showTimeSelect={true}
                  showTimeSelectOnly={true}
                  dateFormat="h:mm aa"
                  className={`w-full bg-transparent outline-none border-b border-[#FFF] border-opacity-40 text-white py-2 focus:outline-none ${!newNotification.time ? 'text-opacity-40' : ''} text-[14px]`}
                  placeholderText={newNotification.time?.display || "Time"}
                  style={{ fontFamily: 'Aeonik' }}
                  required
                />
              </div>
              <button
                type="submit"
                className="bg-[#DF0F11] h-8 flex items-center justify-between w-full text-white px-4 py-2 rounded mt-4"
              >
                <Typography color={'#FFF'} size={'13.168px'} weight={400} text={'Review Notification'} />
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                  <mask id="mask0_1797_7511" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="23" height="23">
                    <rect x="0.6875" y="0.548706" width="21.9469" height="21.9469" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1797_7511)">
                    <path d="M7.31983 15.8658H13.2638V14.4941H7.31983V15.8658ZM7.31983 12.208H16.0071V10.8363H7.31983V12.208ZM7.31983 8.55015H16.0071V7.17847H7.31983V8.55015ZM5.54373 19.295C5.08178 19.295 4.69077 19.135 4.37071 18.8149C4.05065 18.4948 3.89062 18.1038 3.89062 17.6419V5.40237C3.89062 4.94042 4.05065 4.54942 4.37071 4.22936C4.69077 3.9093 5.08178 3.74927 5.54373 3.74927H17.7832C18.2452 3.74927 18.6362 3.9093 18.9563 4.22936C19.2763 4.54942 19.4363 4.94042 19.4363 5.40237V17.6419C19.4363 18.1038 19.2763 18.4948 18.9563 18.8149C18.6362 19.135 18.2452 19.295 17.7832 19.295H5.54373ZM5.54373 17.9233H17.7832C17.8537 17.9233 17.9181 17.894 17.9767 17.8353C18.0353 17.7768 18.0647 17.7123 18.0647 17.6419V5.40237C18.0647 5.33196 18.0353 5.26749 17.9767 5.20896C17.9181 5.15029 17.8537 5.12095 17.7832 5.12095H5.54373C5.47332 5.12095 5.40885 5.15029 5.35032 5.20896C5.29165 5.26749 5.26231 5.33196 5.26231 5.40237V17.6419C5.26231 17.7123 5.29165 17.7768 5.35032 17.8353C5.40885 17.894 5.47332 17.9233 5.54373 17.9233Z" fill="white" />
                  </g>
                </svg>
              </button>
            </form>
          </div>
        </div>
      </div>}
      {openLicense && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50" onClick={() => setOpenLicense(false)}>
          <div className="bg-[#121212] p-4 rounded-lg max-w-4xl max-h-[90vh] overflow-auto" onClick={(e) => e.stopPropagation()}>
            <img src={user?.license ? `${process.env.REACT_APP_BACKEND_URL}${user?.license}` : ''} alt="Preview" className="max-w-full max-h-[80vh]" />
            {/* <button onClick={() => setShowPreviewModal(false)} className="mt-4 bg-red-500 text-white px-4 py-2 rounded">Close</button> */}
          </div>
        </div>
      )}
      {openMarkPayout && <div className="fixed fade inset-0 z-50 flex items-center h-full justify-center bg-black bg-opacity-60 animate-backdropFadeIn">
        <div className="relative w-[661px] mx-auto animate-modalSlideIn">
          <svg xmlns="http://www.w3.org/2000/svg" width="661" height="447" viewBox="0 0 661 447" fill="none">
            <path d="M0 59.1943L58.5 0H661V447H0V59.1943Z" fill="#1B1B1B" />
          </svg>
          <div className="absolute inset-0 flex flex-col py-[42px] px-[66px] text-center text-white">
            {/* Close Icon */}
            <button
              onClick={() => setOpenMarkPayout(false)}
              className="absolute top-6 right-6 text-white text-lg hover:text-gray-300"
              aria-label="Close modal"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <g opacity="0.6">
                  <mask id="mask0_1769_5697" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="30" height="30">
                    <rect width="30" height="30" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1769_5697)">
                    <path d="M8.00078 23.317L6.68359 21.9998L13.6836 14.9998L6.68359 7.99981L8.00078 6.68262L15.0008 13.6826L22.0008 6.68262L23.318 7.99981L16.318 14.9998L23.318 21.9998L22.0008 23.317L15.0008 16.317L8.00078 23.317Z" fill="white" />
                  </g>
                </g>
              </svg>
            </button>
            <div className='flex items-center justify-center'>
              <svg xmlns="http://www.w3.org/2000/svg" width="86" height="86" viewBox="0 0 86 86" fill="none">
                <mask id="mask0_1797_6142" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="86" height="86">
                  <rect width="86" height="86" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1797_6142)">
                  <path d="M43 60.9167C44.0153 60.9167 44.8663 60.5733 45.5531 59.8865C46.2399 59.1997 46.5833 58.3486 46.5833 57.3333C46.5833 56.3181 46.2399 55.467 45.5531 54.7802C44.8663 54.0934 44.0153 53.75 43 53.75C41.9847 53.75 41.1337 54.0934 40.4469 54.7802C39.7601 55.467 39.4167 56.3181 39.4167 57.3333C39.4167 58.3486 39.7601 59.1997 40.4469 59.8865C41.1337 60.5733 41.9847 60.9167 43 60.9167ZM39.4167 46.5833H46.5833V25.0833H39.4167V46.5833ZM29.5625 75.25L10.75 56.4375V29.5625L29.5625 10.75H56.4375L75.25 29.5625V56.4375L56.4375 75.25H29.5625Z" fill="#DF0F11" />
                </g>
              </svg>
            </div>
            <Typography size={'36px'} className='mt-8' family={'Supply'} color={'#FFF'} transform={'uppercase'} text={'Mark Payout?'} />
            <Typography size={'18px'} className='mt-5' color={'#FFF'} opacity={0.6} text={'What\'s the most recent ROI payout?'} />
            <form className="mt-7">
              <div
                className={`mx-auto rounded-[3.354px] border-[1.677px] w-[306px] h-[62px] px-[30.188px] gap-[16.771px] flex-shrink-0 py-[16.771px] flex items-center justify-center
    ${roiPayout > 0 ? 'border-transparent bg-[#000] opacity-100' : 'border-white bg-[#000] opacity-60'}
  `}
                style={{ fontFamily: 'Aeonik' }}
              >
                <input
                  className={`bg-transparent text-center text-[20.125px] border-none outline-none ${Number(roiPayout) > 0 ? 'text-[#DF0F11]' : 'text-[#FFF]'} `}
                  type="text"
                  value={
                    isEditing
                      ? roiPayout
                      : roiPayout !== ''
                        ? `$${Number(roiPayout).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''
                  }
                  onFocus={() => setIsEditing(true)}
                  onBlur={() => setIsEditing(false)}
                  onChange={e => {
                    const raw = e.target.value.replace(/[^0-9.]/g, '');
                    setRoiPayout(raw);
                  }}
                  style={{ fontFamily: 'Aeonik' }}
                  required
                />
              </div>
              <CustomButton onClick={() => {
                if (Number(roiPayout) > 0 && Number(roiPayout) <= remainingPayout) {
                  setOpenMarkPayout(false);
                  setOpenConfirmRecentRoiPayout(true);
                } else if (Number(roiPayout) > remainingPayout) {
                  setOpenMarkPayout(false);
                  setOpenValidationErrorModal(true);
                }
              }} className='mt-12 w-full' text={'NEXT'} />
            </form>
          </div>
        </div>
      </div>
      }

      {openValidationErrorModal && (
        <CustomModal
          type="error"
          title="INVALID PAYOUT"
          message={`The payout amount ($${Number(roiPayout).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}) exceeds the remaining payout ($${Number(remainingPayout).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}). Please enter a valid amount.`}
          onClose={() => {
            setOpenValidationErrorModal(false);
            setOpenMarkPayout(true); // Reopen Mark Payout modal to allow correction
          }}
          colseText="CLOSE"
        />
      )}

      {openConfirmRecentRoiPayout && <div className="fixed fade inset-0 z-50 flex items-center h-full justify-center bg-black bg-opacity-60 animate-backdropFadeIn">
        <div className="relative w-[661px] mx-auto animate-modalSlideIn">
          <svg xmlns="http://www.w3.org/2000/svg" width="661" height="447" viewBox="0 0 661 447" fill="none">
            <path d="M0 59.1943L58.5 0H661V447H0V59.1943Z" fill="#1B1B1B" />
          </svg>
          <div className="absolute inset-0 flex flex-col py-4 px-[66px] text-center text-white">
            {/* Close Icon */}
            <button
              onClick={() => setOpenConfirmRecentRoiPayout(false)}
              className="absolute top-6 right-6 text-white text-lg hover:text-gray-300"
              aria-label="Close modal"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <g opacity="0.6">
                  <mask id="mask0_1769_5697" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="30" height="30">
                    <rect width="30" height="30" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1769_5697)">
                    <path d="M8.00078 23.317L6.68359 21.9998L13.6836 14.9998L6.68359 7.99981L8.00078 6.68262L15.0008 13.6826L22.0008 6.68262L23.318 7.99981L16.318 14.9998L23.318 21.9998L22.0008 23.317L15.0008 16.317L8.00078 23.317Z" fill="white" />
                  </g>
                </g>
              </svg>
            </button>
            <div className='flex items-center justify-center'>
              <svg xmlns="http://www.w3.org/2000/svg" width="86" height="86" viewBox="0 0 86 86" fill="none">
                <mask id="mask0_1797_6142" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="86" height="86">
                  <rect width="86" height="86" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1797_6142)">
                  <path d="M43 60.9167C44.0153 60.9167 44.8663 60.5733 45.5531 59.8865C46.2399 59.1997 46.5833 58.3486 46.5833 57.3333C46.5833 56.3181 46.2399 55.467 45.5531 54.7802C44.8663 54.0934 44.0153 53.75 43 53.75C41.9847 53.75 41.1337 54.0934 40.4469 54.7802C39.7601 55.467 39.4167 56.3181 39.4167 57.3333C39.4167 58.3486 39.7601 59.1997 40.4469 59.8865C41.1337 60.5733 41.9847 60.9167 43 60.9167ZM39.4167 46.5833H46.5833V25.0833H39.4167V46.5833ZM29.5625 75.25L10.75 56.4375V29.5625L29.5625 10.75H56.4375L75.25 29.5625V56.4375L56.4375 75.25H29.5625Z" fill="#DF0F11" />
                </g>
              </svg>
            </div>
            <Typography size={'36px'} className='mt-8' family={'Supply'} color={'#FFF'} transform={'uppercase'} text={'ARE YOU SURE?'} />
            <Typography size={'18px'} className='mt-5' color={'#FFF'} opacity={0.6} text={'Confirm Recent ROI Payout!'} />
            <form className="mt-7">
              <div
                className={`mx-auto rounded-[3.354px] border-[1.677px] w-[306px] h-[62px] px-[30.188px] gap-[16.771px] flex-shrink-0 py-[16.771px] flex items-center justify-center
    ${roiPayout > 0 ? 'border-transparent bg-[#161616] opacity-100' : 'border-white bg-[#000] opacity-60'}
  `}
                style={{ fontFamily: 'Aeonik' }}
              >
                <input
                  className={`bg-transparent text-center text-[20.125px] border-none outline-none ${Number(roiPayout) > 0 ? 'text-[#DF0F11]' : 'text-[#FFF]'} `}
                  type="text"
                  value={roiPayout !== ''
                    ? `$${Number(roiPayout).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                    : 0}
                  readOnly
                  style={{ fontFamily: 'Aeonik' }}
                />
              </div>
              <CustomButton onClick={handleConfirmRecentRoiPayout} className='mt-8 w-full' text={'CONFIRM'} />
              <Typography className='mt-4' text={<>REMAINING PAYOUT : <span className='text-[#8C8C8C]'>{formatNumber(remainingPayout)}</span></>} size={'14px'} weight={400} transform={'uppercase'} color={'#FFF'} />
            </form>
          </div>
        </div>
      </div>
      }

      <div className="w-full sm:p-5 p-4 rounded-[4px] bg-black">
        <div className="flex items-center">
          <img src={process.env.REACT_APP_BACKEND_URL + user?.avatar} alt='User Avatar' width={28} height={28} className='rounded-full h-7 w-7' />
          <Typography text={user?.name} className='ml-4' transform={'uppercase'} color={'#FFF'} size={'16px'} weight={400} lineheight={'170%'} family={'Supply'} />
        </div>
        <div className='mt-[25px] flex flex-col sm:flex-row items-start self-stretch justify-between'>
          <div className='grid grid-rows-2 grid-cols-none sm:grid-rows-none sm:grid-cols-2 gap-4'>
            <div className="grid sm:grid-rows-2 sm:grid-cols-none grid-rows-none grid-cols-2 gap-8">
              <div className='flex flex-col gap-2'>
                <Typography text={'PHONE'} size="12px" color="#FFF" lineheight={'170%'} opacity={.6} />
                <Typography text={user?.phone} size="14px" color="#FFF" lineheight={'170%'} />
              </div>
              <div className='flex flex-col gap-2'>
                <Typography text={'EMAIL'} size="12px" color="#FFF" lineheight={'170%'} opacity={.6} />
                <Typography text={user?.email} size="14px" color="#FFF" lineheight={'170%'} />
              </div>
            </div>
            <div className="grid sm:grid-rows-2 sm:grid-cols-none grid-rows-none grid-cols-2 gap-8">
              <div className='flex flex-col gap-2'>
                <Typography text={'Occupancy'} size="12px" color="#FFF" lineheight={'170%'} opacity={.6} />
                <Typography text={user?.occupancy} size="14px" color="#FFF" lineheight={'170%'} />
              </div>
              <div className='flex flex-col gap-2'>
                <Typography text={'ADDRESS'} size="12px" color="#FFF" lineheight={'170%'} opacity={.6} />
                <Typography text={user?.address} size="14px" color="#FFF" lineheight={'170%'} />
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-3 w-44 items-start">
            <Typography text={'Investor ID/Licence'} size="12px" color="#FFF" lineheight={'170%'} opacity={.6} />
            <div
              onClick={() => setOpenLicense(true)}
              className="flex cursor-pointer flex-col justify-center items-center rounded-[6px] w-[161px] h-[97px] border-[1px] border-[#2A2A2A]"
              style={{
                background: `linear-gradient(0deg, rgba(0, 0, 0, 0.90) 0%, rgba(0, 0, 0, 0.90) 100%), url(${user?.license ? `${process.env.REACT_APP_BACKEND_URL}${user?.license}` : ''
                  }) lightgray 50% / cover no-repeat`,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                  fill="#DF0F11"
                />
                <path
                  d="M21.8944 11.5528C19.7362 7.23635 15.9031 5 12 5C8.09687 5 4.26379 7.23635 2.10557 11.5528C1.96481 11.8343 1.96481 12.1657 2.10557 12.4472C4.26379 16.7637 8.09687 19 12 19C15.9031 19 19.7362 16.7637 21.8944 12.4472C22.0352 12.1657 22.0352 11.8343 21.8944 11.5528ZM12 17C9.03121 17 5.99806 15.3792 4.12966 12C5.99806 8.62078 9.03121 7 12 7C14.9688 7 18.0019 8.62078 19.8703 12C18.0019 15.3792 14.9688 17 12 17Z"
                  fill="#DF0F11"
                />
              </svg>
              <Typography
                size="8.293px"
                family="Supply"
                text="VIEW LICENSE"
                color="#DF0F11"
                lineheight="1"
                weight={400}
                transform="uppercase"
              />
            </div>
          </div>
        </div>
        <div className="mt-8 flex flex-col">
          <Typography text={'Investor BIO'} size="12px" color="#FFF" lineheight={'170%'} opacity={.6} />
          <Typography text={user?.bio} size="14px" color="#FFF" lineheight={'170%'} />
        </div>
      </div>

      <div className='mt-8 border-[#262626] border-[1px]'>
        <header className='h-[51px] px-6 flex justify-between items-center bg-[#333]'>
          <Typography className='' color={'#FFF'} size={'16px'} family={'Supply'} weight={400} lineheight={'170%'} transform={'uppercase'} text={'Payout Info'} />
        </header>
        <div className='md:px-6 px-4 py-5 bg-black'>
          <div className=' md:block flex justify-between'>
            <div className="grid md:grid-cols-3 md:grid-rows-none grid-cols-none grid-rows-3 md:gap-0 gap-5">
              <div className="md:col-span-1 row-span-1">
                <Typography className='' color={'#FFF'} size={'12px'} opacity={0.6} weight={400} lineheight={'170%'} text={'Recipient Name:'} />
                <div className="flex gap-2 items-center mt-3">
                  <Typography color={'#FFF'} size={'14px'} weight={400} lineheight={'170%'} text={user?.payoutInfo?.accountName} />
                  <CustomCopyClipboard text={user?.payoutInfo?.accountName} />
                </div>
              </div>
              <div className="md:col-span-1 row-span-1">
                <Typography className='' color={'#FFF'} size={'12px'} opacity={0.6} weight={400} lineheight={'170%'} text={'Bank Name:'} />
                <div className='flex gap-2 items-center mt-3'>
                  <Typography className='' color={'#FFF'} size={'14px'} weight={400} lineheight={'170%'} text={user?.payoutInfo?.bankName} />
                  <CustomCopyClipboard text={user?.payoutInfo?.bankName} />
                </div>
              </div>
              <div className="md:col-span-1 row-span-1">
                <Typography className='' color={'#FFF'} size={'12px'} opacity={0.6} weight={400} lineheight={'170%'} text={'Bank Routing Number:'} />
                <div className='flex gap-2 items-center mt-3'>
                  <Typography color={'#FFF'} size={'14px'} weight={400} lineheight={'170%'} text={user?.payoutInfo?.bankAddress} />
                  <CustomCopyClipboard text={user?.payoutInfo?.bankAddress} />
                </div>
              </div>
            </div>
            <div className="grid md:grid-cols-3 md:grid-rows-none grid-cols-none grid-rows-3 md:gap-0 gap-5  md:mt-9">
              <div className="md:col-span-1 row-span-1">
                <Typography className='' color={'#FFF'} size={'12px'} opacity={0.6} weight={400} lineheight={'170%'} text={'Account Number:'} />
                <div className='flex gap-2 items-center mt-3'>
                  <Typography color={'#FFF'} size={'14px'} weight={400} lineheight={'170%'} text={user?.payoutInfo?.accountNumber} />
                  <CustomCopyClipboard text={user?.payoutInfo?.accountNumber} />
                </div>
              </div>
              <div className="md:col-span-1 row-span-1">
                <Typography className='' color={'#FFF'} size={'12px'} opacity={0.6} weight={400} lineheight={'170%'} text={'SWIFT/BIC Code:'} />
                <div className='flex gap-2 items-center mt-3'>
                  <Typography color={'#FFF'} size={'14px'} weight={400} lineheight={'170%'} text={user?.payoutInfo?.swift_bicCode} />
                  <CustomCopyClipboard text={user?.payoutInfo?.swift_bicCode} />
                </div>
              </div>
              <div className="md:col-span-1 row-span-1">
                <Typography className='' color={'#FFF'} size={'12px'} opacity={0.6} weight={400} lineheight={'170%'} text={'Routing Number:'} />
                <div className='flex gap-2 items-center mt-3'>
                  <Typography color={'#FFF'} size={'14px'} weight={400} lineheight={'170%'} text={user?.payoutInfo?.routingNumber} />
                  <CustomCopyClipboard text={user?.payoutInfo?.routingNumber} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full p-5 mt-[14px] rounded-[4px] bg-black">
        <Typography text={'Pending INVESTMENTS'} transform={'uppercase'} color={'#FFF'} size={'16px'} weight={400} lineheight={'170%'} family={'Supply'} />
        <div className="relative overflow-x-auto mt-3">
          <div className="relative h-36 scrollbar-hide scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent overflow-y-auto overflow-x-auto" >
            <table className="w-full text-sm text-left rtl:text-right">
              <thead className="text-xs text-white opacity-60">
                <tr className="border-b border-[#151515]">
                  {['Amount invested', 'Start Date', 'Period', 'Guaranteed ROI', 'Current amount', 'Milestones'].map((heading, index) => (
                    <th key={index} scope="col" className="lg:px-6 px-1  min-w-[116px] py-3">
                      {heading && <Typography text={heading} size={'12px'} weight={400} />}
                    </th>
                  ))}
                  <th scope='col' className='lg:px-6 px-1  min-w-[116px] py-3'>

                  </th>
                </tr>
              </thead>
              <tbody>
                {(userInvestments || []).filter(
                  (inv) => inv.status === 'pending' || inv.status === 'approved' || inv.status === 'wireConfirmed'
                ).map((investment, index) => {
                  let NextStatus = '';
                  if (investment.status === 'pending') {
                    NextStatus = 'ReviewSign';
                  } else if (investment.status === 'approved') {
                    NextStatus = 'WireTransfer';
                  } else if (investment.status === 'wireConfirmed') {
                    NextStatus = 'Active';
                  }
                  const startDate = new Date(investment.startDate);
                  const endDate = new Date(investment.endDate);
                  const currentAmount = calculateCurrentAmount(investment);
                  const periodDays = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));
                  return (
                    <tr
                      key={index}
                      className={`border-b py-4 border-[#151515] h-[50px] text-white`}
                    >
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={formatNumber(investment.initialInvestment)} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={startDate.toLocaleDateString()} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={`${periodDays} days`} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={`${investment.annualROI}%`} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={formatNumber(currentAmount)} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={investment.monthlyBreakdown?.length.toString() || '0'} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] text-center">
                        <div className='flex items-center justify-around '>
                          <Typography onClick={() => navigate(`/view-contract/${investment?._id}`)} className="cursor-pointer" text={'VIEW AGREEMENT'} size={'12px'} textDecorationLine={'underline'} textDecorationStyle={'solid'} textDecorationSkipInk={'none'} textDecorationThickness={'auto'} textUnderlineOffset={'auto'} textUnderlinePosition={'from-font'} lineheight={'170%'} family={'Supply'} weight={400} transform={'uppercase'} color={'#DF0F11'} />
                          <button
                            onClick={() => { handleShowRejectModal(investment._id) }}
                            className={`flex items-center h-7 justify-center rounded-sm px-[18px] py-[10px] border-[#FFF] border-[1px] bg-[#000000]`}
                          >
                            <Typography text={"Reject"} color={'#FFF'} size={'12px'} weight={400} lineheight={'170%'} />
                          </button>
                          <button
                            onClick={() => NextStatus && NextStatus === 'Active' ? handleShowActiveModal(investment._id) : NextStatus === 'WireTransfer' ? handleShowWireModal(investment._id) : NextStatus === 'ReviewSign' && navigate(`/admin/review-sign/${investment?._id}`)}
                            className={`flex items-center min-w-28 h-7 justify-center rounded-sm px-[18px] py-[10px] border-[#FFF] border-[1px] bg-white`}
                          >
                            <Typography text={NextStatus} color={'#000'} size={'12px'} weight={400} lineheight={'170%'} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="w-full p-5 mt-[14px] rounded-[4px] bg-black">
        <Typography text={'ACTIVE INVESTMENTS'} transform={'uppercase'} color={'#FFF'} size={'16px'} weight={400} lineheight={'170%'} family={'Supply'} />
        <div className="relative overflow-x-auto mt-3">
          {/* <table className="w-full text-sm text-left rtl:text-right table-fixed">
                <thead className="text-xs text-white opacity-60">
                  <tr className="border-b border-[#151515]">
                    {['Amount invested', 'Start Date', 'Period', 'Guaranteed ROI', 'Current amount', 'Days remaining', 'Milestones'].map((heading, index) => (
                      <th key={index} scope="col" className="lg:px-6 px-1 w-[92px] w-auto py-3">
                        {heading && <Typography text={heading} size={'12px'} weight={400} />}
                      </th>
                    ))}
                    <th scope='col' className='lg:px-6 px-1 w-12 py-3'>

                    </th>
                  </tr>
                </thead>
              </table> */}
          <div className="relative h-36 scrollbar-hide scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent overflow-y-auto overflow-x-auto" >
            <table className="w-full text-sm text-left rtl:text-right">
              <thead className="text-xs text-white opacity-60">
                <tr className="border-b border-[#151515]">
                  {['Amount invested', 'Start Date', 'Period', 'Guaranteed ROI', 'Current amount', 'Days remaining', 'Milestones'].map((heading, index) => (
                    <th key={index} scope="col" className="lg:px-6 px-1  min-w-[116px] py-3">
                      {heading && <Typography text={heading} size={'12px'} weight={400} />}
                    </th>
                  ))}
                  <th scope='col' className='lg:px-6 px-1  min-w-[116px] w-12 py-3'>

                  </th>
                </tr>
              </thead>
              <tbody>
                {(userInvestments || []).filter(
                  (inv) => inv.status === 'completed'
                ).map((investment, index) => {
                  const startDate = new Date(investment.startDate);
                  const endDate = new Date(investment.endDate);
                  const daysRemaining = calculateDaysRemaining(investment.endDate);
                  const currentAmount = calculateCurrentAmount(investment);
                  const periodDays = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));
                  return (
                    <tr
                      key={index}
                      onClick={() => setActiveIndex(index)}
                      className={`border-b py-4 border-[#151515] h-[50px] text-white ${index === activeIndex ? 'bg-[#DF0F11]' : ''}`}
                    >
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={formatNumber(investment.initialInvestment)} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={startDate.toLocaleDateString()} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={`${periodDays} days`} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={`${investment.annualROI}%`} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={formatNumber(currentAmount)} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={`${daysRemaining} days`} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] ">
                        <Typography className='' text={investment.monthlyBreakdown?.length.toString() || '0'} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-1  min-w-[116px] text-center">
                        <button
                          onClick={() => {/* handleViewInvestment(investment._id) */ }}
                          className={`flex items-center h-7 justify-center rounded-sm px-[18px] py-[10px] border-[#FFF] border-[1px] ${index === activeIndex ? 'bg-white' : 'bg-[#000000] opacity-60'}`}
                        >
                          <Typography text={"View"} color={index === activeIndex ? '#000' : '#FFF'} size={'12px'} weight={400} lineheight={'170%'} />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className='w-full p-6 rounded-[4px] mt-3 bg-black'>
        <div className='grid grid-cols-11 lg:gap-4 gap-[30px]'>
          <div className="lg:col-span-7 col-span-11 block">
            <div className='flex justify-between items-center sm:pr-10'>
              <Typography text={'CLIENT MILESTONES'} size={'16px'} family={'Supply'} weight={400} transform={'uppercase'} color={'#FFF'} />
              <Typography onClick={() => navigate(`/view-contract/${oldestInvestment?._id}`)} className="cursor-pointer" text={'VIEW AGREEMENT'} size={'12px'} textDecorationLine={'underline'} textDecorationStyle={'solid'} textDecorationSkipInk={'none'} textDecorationThickness={'auto'} textUnderlineOffset={'auto'} textUnderlinePosition={'from-font'} lineheight={'170%'} family={'Supply'} weight={400} transform={'uppercase'} color={'#DF0F11'} />
            </div>
            <MilestoneList title={<>NEXT PAYOUT : <span className='text-[#999999]'>{formatNumber(nextPayout)}</span></>} className={'mt-4'} content={'Track your client’s next payout, milestone, or return status.'} />
            <CustomRange
              milestones={milestones}
              progress={progress}
            />
            <div className="mt-20">
              <Typography family={'Supply'} text={<>REMAINING PAYOUT : <span className='text-[#DF0F11]'>{formatNumber(remainingPayout)}</span></>} size={'14px'} weight={400} transform={'uppercase'} color={'#FFF'} />
            </div>
          </div>
          <div className="lg:col-span-2 md:col-span-6 col-span-11">
            <Typography lineheight={'170%'} text={'Payout Schedule'} size={'14px'} weight={400} color={'#FFF'} />
            <Typography className="mt-[17px]" lineheight={'150%'} text={'Make sure to track client payouts and returns, and keep them updated on progress and upcoming payout dates.'} size={'12px'} weight={400} opacity={0.6} color={'#FFF'} />
            <div className="h-[1px] bg-white opacity-20 mt-[17px] w-full" />
            <div className="mt-[15px] grid grid-cols-8">
              <div className="col-span-5">
                <Typography lineheight={'170%'} text={'Client Investment'} size={'12px'} weight={400} color={'#DF0F11'} />
                <Typography lineheight={'170%'} text={formatNumber(currentAmount)} size={'20px'} weight={500} family={'Supply'} color={'#FFF'} className="mt-[12px]" />
              </div>
              <div className="col-span-3">
                <Typography lineheight={'170%'} text={'Target Investment'} size={'12px'} weight={400} color={'#DF0F11'} />
                <Typography lineheight={'170%'} text={oldestInvestment ? formatNumber(oldestInvestment.totalROI) : '$0'} size={'20px'} weight={500} family={'Supply'} color={'#FFF'} className="mt-[12px]" />
              </div>
            </div>
          </div>
          <div className="lg:col-span-2 md:col-span-5 col-span-11">
            <div className='flex items-center justify-between'>
              <Typography lineheight={'170%'} text={'Time Remaining'} size={'16px'} family={'Supply'} weight={400} color={'#FFF'} />
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <mask id="mask0_1797_8621" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
                  <rect width="14" height="14" transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 14 14)" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1797_8621)">
                  <path d="M1.36815 9.32445L2.19605 10.1523L6.9995 5.34889L11.803 10.1523L12.6309 9.32445L6.9995 3.69309L1.36815 9.32445Z" fill="white" />
                </g>
              </svg>
            </div>
            <div className='flex items-center justify-between mt-5 max-md:gap-[18px]'>
              <TimeList title={timeRemaining.days.toString()} content={'Days'} />
              <TimeList title={timeRemaining.hours.toString()} content={'Hours'} />
              <TimeList title={timeRemaining.minutes.toString()} content={'Minutes'} />
              <TimeList title={timeRemaining.seconds.toString()} content={'Seconds'} />
            </div>
            <div onClick={() => setOpenReviewModal(true)} className='border-[2px] cursor-pointer h-[28px] bg-white border-[#FFF] rounded-sm px-[10px] py-[18px] flex items-center justify-center gap-[10px]'>
              <Typography text={'Send Notification'} size={'12px'} lineheight={'170%'} weight={400} color={'#000'} />
            </div>
            <div onClick={() => setOpenMarkPayout(true)} className='border-[2px] cursor-pointer mt-[10px] h-[28px] bg-[#DF0F11] border-[#3B3B3B] rounded-sm px-[10px] py-[18px] flex items-center justify-center gap-[10px]'>
              <Typography text={'Mark Payout'} size={'12px'} lineheight={'170%'} weight={400} color={'#FFFFFF'} />
            </div>
          </div>
        </div>
        <div className='mt-[35px] h-[1px] opacity-10 bg-white w-full' />
        {oldestInvestment?.monthlyBreakdown?.map((milestone, index) => {
          // const now = new Date();
          // const startDate = new Date(oldestInvestment.startDate);
          // const monthsElapsed = Math.floor((now - startDate) / (1000 * 60 * 60 * 24 * 30));
          if (milestone.status === 'completed') {
            return (
              <React.Fragment key={index}>
                <MilestoneList
                  className={'py-[18px]'}
                  title={`Milestone ${milestone.month} Completed`}
                  content={`Milestone ${milestone.month} complete — you’ve received ${formatNumber(milestone.accumulatedReturn)}. Your next milestone will return ${formatNumber(nextPayout)}.`}
                />
                <div className='h-[1px] opacity-10 bg-white w-full' />
              </React.Fragment>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default Investment;